(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["k24-card-alt-image"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.k24CardAltReady) return;
    window.k24CardAltReady = true;
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    /** @param {Element} card */
    const loadAlt = (card) => {
      const img = card.querySelector('img.k24-card-alt[data-k24-srcset]');
      if (!img) return;
      img.sizes = img.dataset.k24Sizes || '50vw';
      img.srcset = img.dataset.k24Srcset;
      img.removeAttribute('data-k24-srcset');
      const markReady = () => img.classList.add('is-ready');
      if (img.complete && img.naturalWidth > 0) {
        markReady();
        return;
      }
      img.addEventListener('load', markReady, { once: true });
    };

    document.addEventListener(
      'pointerover',
      (event) => {
        if (!finePointer.matches || event.pointerType === 'touch') return;
        const target = event.target;
        if (!(target instanceof Element)) return;
        const card = target.closest('.product-item__wrapper');
        if (card) loadAlt(card);
      },
      { passive: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
